<script lang="ts" setup>
import type { BannerUpsellOfferContent } from '@ts-upsell-banner/interfaces'

import promoCodeSvg from '@images/banners/upsell-halloween/promo-code.svg'

defineOptions({
  name: 'BannerUpsellOfferText',
})

defineProps<BannerUpsellOfferContent>()
</script>

<template>
  <span class="banner-upsell-offer-text">
    {{ lead }}
    <span class="banner-upsell-offer-text__kid">{{ kid }}</span>
    <span
      v-if="code"
      class="banner-upsell-offer-text__code"
    >
      <span class="banner-upsell-offer-text__code-text btly-text-body-m">{{ code }}</span>
      <span class="banner-upsell-offer-text__code-lettering">
        <img
          :src="promoCodeSvg"
          class="banner-upsell-offer-text__code-image"
          :alt="code"
        >
      </span>
    </span>
  </span>
</template>

<style scoped lang="scss" src="@scss/components/Atoms/UpsellBanner/BannerUpsellOfferText.scss" />
